<script>
	import CountriesOptions from "../lib/components/countriesOptions.svelte";
	import CityList from "../lib/components/cityList.svelte";
	import { Basket } from "../lib/stores/basket";
	import {onMount} from 'svelte';
	import { track } from 'fbq';
	import GooglePlacesAutocomplete from '@silintl/svelte-google-places-autocomplete';
	import Datepicker from 'svelte-calendar';
	import moment from "moment";

	var isMobile = navigator.userAgent.match(/(iPad)|(iPhone)|(iPod)|(android)|(webOS)/i);
	
	let shippingInfo = {
		shippingAddress: {
			...$Basket.shipping.shippingAddress,
			pincode: $Basket.shipping.pincode
		},
		billingAddress: {sameAsShipping: true},
		saveInfo: true
	}

	let locationName = shippingInfo.shippingAddress.address;
	let gpOptions = {
		fields: ['address_components']
	}

	let error="";

	let timeslots = {};
	$: $Basket.deleveryDate, fetch('https://crm.lamara.in/products/products/getdeliverytimeslots?delivery_date='+$Basket.deleveryDate).then(res => res.json()).then(res => {
		timeslots = res;
	});

	const onSubmit = e => {
		error = "";
		let delivery_time = "";
		if(e.currentTarget.elements.delivery_time && e.currentTarget.elements.delivery_time.value)
		delivery_time = e.currentTarget.elements.delivery_time.value;
		track('InitiateCheckout', {
			content_category: 'cakes',
			content_ids: $Basket.items.map(p => p.item_no),
			contents: $Basket.items,
			num_items: $Basket.items.length
		});
		fetch("https://crm.lamara.in/products/products/saveorderapi",{
			method: "POST",
			body: JSON.stringify({
				...shippingInfo.shippingAddress,
				delivery_date: $Basket.deleveryDate,
				cart_items: $Basket.items,
				delivery_time
			})
		}).then(res => res.json()).then(res => {
			if(res.error){
				error = res.data.error_message;
			}else{
				$Basket.shipping = shippingInfo.saveInfo ? {
					...$Basket.shipping,
					...shippingInfo
				} : {};
				$Basket.order_id = res.order_id;
				$Basket.payment_url = res.return_url;
				$Basket.items = [];
				$Basket.deleveryDate = null;
				document.location = '/order/'+res.order_id;
			}
		});
	}
	let addressEl;
	const onPlaceChanged = e => {
		shippingInfo.shippingAddress.address = e.detail.text;
	}
	const onGPReady = e => {
	}

	let date = $Basket.deleveryDate;
	if(!isMobile){
        date = $Basket.deleveryDate ? moment($Basket.deleveryDate).toDate() == 'Invalid Date' ? new Date() : moment($Basket.deleveryDate).toDate() : new Date();
    }

	$: date, (()=>{
        let updateDate = isMobile ? date : moment(date).format("YYYY-MM-DD")
		if($Basket.deleveryDate != updateDate){
			shippingInfo.shippingAddress.delivery_time = null;
			$Basket.deleveryDate = updateDate;
		}
    })()
</script>
<section id="" class="form-page">
	<div class="container">
		<div class="col-md-6 container bg-default">
			{#if error !=""}
				<div class="invalid-feedback">
					{error}
				</div>
			{/if}
			<form on:submit|preventDefault={onSubmit} autocomplete="off">
				<div class="form-row">
					<div class="col-md-6 form-group">
						<label for="firstname">Name</label>
						<input type="text" class="form-control" id="firstname" placeholder="First Name" bind:value={shippingInfo.shippingAddress.customer_name} required>
					</div>
				</div>
				<div class="form-row">
					<div class="col-md-6 form-group">
						<label for="phone">Phone</label>
						<input maxlength="10" type="tel" class="form-control" id="phone" placeholder="Phone" bind:value={shippingInfo.shippingAddress.phone} required>
					</div>
				</div>
				<div class="form-row">
					<div class="col-md-6 form-group">
						<label for="phone">Alternate Contact
							<span class="text-muted">(Optional)</span>
						</label>
						<input maxlength="10" type="tel" class="form-control" id="phone" placeholder="Phone" bind:value={shippingInfo.shippingAddress.alt_phone}>
					</div>
				</div>
				<div class="form-row">
					<div class="col-md-12 form-group">
						<label for="date">Delivery date</label>
						{#if isMobile}
							<input class="form-control form-control-sm" type="date" placeholder="Select date" bind:value={date} min={moment().format("YYYY-MM-DD")}>
						{:else}
							<div class="row no-gutters">
								<span class="form-control form-control-sm col-8 text-center">{moment(date).format('Do MMMM YYYY')}</span>
								<div class="col-4">
									<Datepicker class="col-4" start={new Date()} bind:selected={date} format={''}/>
								</div>
							</div>
						{/if}
					</div>
				</div>
				<div class="form-row">
					<div class="col-md-12 form-group">
						<label for="date">Delivery time</label>
						{#if timeslots.data && !timeslots.error}
							<select class="form-control" placeholder="Select Slot" name="delivery_time" required bind:value={shippingInfo.shippingAddress.delivery_time}>
								<option value="">Select time slot</option>
								{#each timeslots.data as slot}
									<option value={slot.id}>{slot.name}</option>
								{/each}
							</select>
						{:else}
							<span class="form-control" style="height: auto;">{timeslots.data}</span>
						{/if}
					</div>
				</div>
				<div class="form-group">
					<label for="email">Email</label>
					<input type="email" class="form-control" id="email" placeholder="you@example.com" required bind:value={shippingInfo.shippingAddress.email}>
					<small>Mentioned email ID will receive the Order confirmation receipt post payment</small>
				</div>
				<div class="form-group">
					<label for="address2">House/Appartment number
					</label>
					<input type="text" class="form-control" id="adress2" placeholder="Flat No" bind:value={shippingInfo.shippingAddress.hno} required>
				</div>
				<div class="form-group">
					<label for="adress">Address</label>
					<textarea type="text" bind:this={addressEl} class="form-control" id="adress" placeholder="1234 Main Street" required bind:value={shippingInfo.shippingAddress.address} rows="3"/>
					<!-- <GooglePlacesAutocomplete apiKey="AIzaSyBxSU0CvoFMxo_wo_b6eu61SkRIzb67daw" class="form-control"
                          on:place_changed={onPlaceChanged} options={gpOptions}
                          on:ready={onGPReady} placeholder="Street Number 4"
                          value={locationName}/> -->
				</div>
				<div class="form-group">
					<label for="adress">Pincode</label>
					<input type="text" class="form-control" placeholder="1234 Main Street" required disabled bind:value={shippingInfo.shippingAddress.pincode}>
					<a href="#" on:click|preventDefault={e => {
						$Basket.shipping = {};
					}}>Change</a>
				</div>
				<div class="row">
					<!-- <div class="col-md-6 form-group">
						<label for="country">Country</label>
						<select type="text" class="form-control" id="country">
							<option value>Choose...</option>
							<option>India</option>
						</select>
					</div> -->
					<!-- <div class="col-md-6 form-group">
						<label for="city">City</label>
						<select type="text" class="form-control" id="city">
							<option value>Choose...</option>
							<option>Hyderabad</option>
						</select>
					</div> -->
				</div>
				<hr>
				<div class="form-check">
					<input type="checkbox" class="form-check-input" id="shipping-adress" bind:checked={shippingInfo.billingAddress.sameAsShipping}> 
						Billing address is the same as my shipping address
					<label for="shipping-adress" class="form-check-label"></label>
				</div>
				<div class="form-check">
					<input type="checkbox" class="form-check-input" id="same-adress" bind:checked={shippingInfo.saveInfo}>
						Save this information for next time
					<label for="same-adress" class="form-check-label"></label>					
				</div>
				{#if !shippingInfo.billingAddress.sameAsShipping}
					<div class="form-group">
						<label for="email">Email</label>
						<input type="email" class="form-control" id="email" placeholder="you@example.com" required bind:value={shippingInfo.billingAddress.email}>
					</div>
					<div class="form-group">
						<label for="adress">Address</label>
						<input type="text" class="form-control" id="adress" placeholder="1234 Main Street" required bind:value={shippingInfo.billingAddress.address}>
					</div>
					<div class="form-group">
						<label for="address2">Address 2
							<span class="text-muted">(Optional)</span>
						</label>
						<input type="text" class="form-control" id="adress2" placeholder="Flat No" bind:value={shippingInfo.billingAddress.hno}>
					</div>
					<div class="row">
						<div class="col-md-6 form-group">
							<label for="country">Country</label>
							<select type="text" class="form-control" id="country" bind:value={shippingInfo.billingAddress.country} required>
								<option>Choose...</option>
								<CountriesOptions/>
							</select>
						</div>
						{#if shippingInfo.billingAddress.country=='India'}
						<div class="col-md-6 form-group">
							<label for="city">City</label>
							<select type="text" class="form-control" id="city" bind:value={shippingInfo.billingAddress.city} required>
								<option value>Choose...</option>
								<CityList/>
							</select>
						</div>
						{/if}
					</div>
				{/if}
				<hr class="mb-4">
				<button class="btn btn-primary bt-lg btn-block" type="submit" disabled={!shippingInfo.shippingAddress.delivery_time}>Place Order</button>
			</form>
		</div>
	</div>
</section>

<style lang="scss">
	.section-title{
		padding: 6em 0 1em 0;
	}

	.form-page {
		min-height: 70vh;
	}

	.invalid-feedback{
		display: block;
	}
</style>